import React from 'react'

import Section from '@/components/Section'
import SectionFooter from '@/components/SectionFooter'
import transformTextToSlug from '../../utils/transformTextToSlug'
import { getParentLocationForCityTypeOrDefaultToTitle } from '../../domain/location/useCases/getParentLocationForCityTypeOrDefaultToTitle'
import { shouldShowCoOccurringCenters } from '../../domain/useCases/shouldShowCoOccurringCenters'
import CenterCarousel from '../molecules/CenterCarousel/CenterCarousel'
import { ArrowRight } from 'react-bootstrap-icons'
import LinkButton from '@/components/atoms/LinkButton/LinkButton'

export default function CoOccurringCenters({
  location,
  shouldDefaultRegionalize,
  coOccurringDisorders,
  hitsCount,
  pageType
}) {
  const headerLocationTitle =
    getParentLocationForCityTypeOrDefaultToTitle(location)

  const showCoOcurringCenters = shouldShowCoOccurringCenters({
    pageType,
    coOccurringDisordersCenters: coOccurringDisorders.edges,
    feedCount: hitsCount
  })

  if (!showCoOcurringCenters) {
    return null
  }

  return (
    <Section>
      <CenterCarousel
        HeaderTag="H2"
        containerId="dualDiagnosisScroll"
        centers={coOccurringDisorders.edges.map(({ node }) => node)}
        sectionHeading={`Dual Diagnosis Treatment in ${headerLocationTitle}`}
        sectionSubHeading="Therapy for co-occurring mental health and substance use disorders, treating both conditions through integrated care."
        zoneId="DualDiagnosis"
        noPadding={true}
        isLoading={false}
        shouldHideAdTags={true}
        termTitle={'Co-Occurring Disorders'}
        useFieldsVariable
      />
      <SectionFooter space="xl">
        <LinkButton
          label={`View All Dual Diagnosis Treatment ${
            shouldDefaultRegionalize ? 'Centres' : 'Centers'
          } in ${headerLocationTitle}`}
          href={`/${transformTextToSlug(
            headerLocationTitle
          )}/co-occurring-disorders/`}
          size="large"
          underline="always"
          iconElement={
            <ArrowRight
              size="16"
              className="ml-1"
            />
          }
        />
      </SectionFooter>
    </Section>
  )
}
